import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { getDictionary } from '@/core/utils/dictionary';

import type { Locale } from '../../../i18n-config';

export type Dictionary = Awaited<ReturnType<typeof getDictionary>>;

const DictionaryContext = createContext<Dictionary | null>(null);
const LocaleContext = createContext<Locale | null>(null);

export function DictionaryProvider({
  dictionary,
  locale,
  children,
}: {
  dictionary: Dictionary;
  locale: Locale;
  children: ReactNode;
}) {
  return (
    <LocaleContext.Provider value={locale}>
      <DictionaryContext.Provider value={dictionary}>
        {children}
      </DictionaryContext.Provider>
    </LocaleContext.Provider>
  );
}

export function useDictionary() {
  const dictionary = useContext(DictionaryContext);
  if (dictionary === null) {
    throw new Error(
      'useDictionary hook must be used within DictionaryProvider',
    );
  }

  return dictionary;
}

export function useLocale() {
  const locale = useContext(LocaleContext);
  if (locale === null) {
    throw new Error('useLocale hook must be used within DictionaryProvider');
  }

  return locale;
}
